import {
  INV_STATUS_BRANCH_LABEL,
  isSelectableForWarehouseTransfer,
} from '../../constants/inventory-status-labels';
import { InventoryItem } from '../../types/inventory';

export type TransferScanContext = 'warehouse' | 'branch';

export const isSelectableForBranchTransfer = (item: InventoryItem): boolean =>
  item.status === INV_STATUS_BRANCH_LABEL && item.availabilityStatus === 'Disponible';

export const isSelectableForTransferScan = (
  item: InventoryItem,
  context: TransferScanContext,
): boolean =>
  context === 'warehouse'
    ? isSelectableForWarehouseTransfer(item)
    : isSelectableForBranchTransfer(item);

export type TransferScanSelectionResult =
  | { kind: 'selected'; item: InventoryItem }
  | { kind: 'already_selected'; item: InventoryItem }
  | { kind: 'not_transferable'; item: InventoryItem }
  | { kind: 'not_found' };

export function resolveTransferScanSelection(
  code: string,
  items: InventoryItem[],
  selectedIds: string[],
  context: TransferScanContext,
): TransferScanSelectionResult {
  const normalized = code.trim();
  if (!normalized) {
    return { kind: 'not_found' };
  }

  const lower = normalized.toLowerCase();
  const exactMatch = items.find((item) => item.id.toLowerCase() === lower);

  if (!exactMatch) {
    return { kind: 'not_found' };
  }

  if (selectedIds.includes(exactMatch.id)) {
    return { kind: 'already_selected', item: exactMatch };
  }

  if (!isSelectableForTransferScan(exactMatch, context)) {
    return { kind: 'not_transferable', item: exactMatch };
  }

  return { kind: 'selected', item: exactMatch };
}

export function transferScanSelectionMessage(result: TransferScanSelectionResult): {
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
} {
  switch (result.kind) {
    case 'selected':
      return {
        message: `Pieza ${result.item.id} agregada a la transferencia`,
        severity: 'success',
      };
    case 'already_selected':
      return {
        message: `La pieza ${result.item.id} ya está seleccionada`,
        severity: 'info',
      };
    case 'not_transferable':
      return {
        message: `La pieza ${result.item.id} no está disponible para transferencia`,
        severity: 'warning',
      };
    case 'not_found':
      return {
        message: 'Código no encontrado',
        severity: 'warning',
      };
  }
}
